import React, { useState } from 'react';
import UploadTabSkeleton from '../UploadTabSkeleton';
import { getXMLFileTypes } from '../../../../utils/string';
import StellarCellebriteXMLMetadata from '../../../Metadata/StellarCellebriteXMLMetadata';
import LabelledSelect from '../../../LabelledSelect';
import { FormControl, FormHelperText, MenuItem } from '@mui/material';
import TabHeader from '../../../TabHeader';
import { UploadFormProvider } from '../UploadFormContext';
import { UploadFormStep } from '../UploadTabSkeleton/stepWrapper';

const STELLAR_OPTIONS = ['Cellebrite XML'] as const;
type StellarOptions = (typeof STELLAR_OPTIONS)[number];

const StellarCellebriteTab: React.FC = () => {
	const [stellarChoice, setStellarChoice] = useState<StellarOptions>('Cellebrite XML');

	const chooseProcessor = () => {
		switch (stellarChoice) {
			case 'Cellebrite XML':
				return <StellarCellebriteXMLMetadata />;
		}
	};

	return (
		<UploadFormProvider>
			<TabHeader />
			<UploadTabSkeleton allowedFormats={getXMLFileTypes()} data-testid="stellar-cellebrite-tab-content">
				<UploadFormStep
					label="Select a Stellar Processor"
					valid={Boolean(stellarChoice)}
					validLabel={`Stellar Processor Selected (${stellarChoice})`}
					errorMessage="A Stellar Processor must be selected"
				>
					<FormControl>
						<LabelledSelect
							fullWidth
							value={stellarChoice}
							onChange={(e) => setStellarChoice(e.target.value as StellarOptions)}
							selectLabel="Stellar Processor"
							testId="stellar-type-selector"
							disabled
						>
							{STELLAR_OPTIONS.map((opt) => {
								return (
									<MenuItem key={`opt-${opt}`} value={opt} data-test={`stellar-choice-opt-${opt}`}>
										{opt}
									</MenuItem>
								);
							})}
						</LabelledSelect>
						<FormHelperText>Only Cellebrite XML is supported in the current release</FormHelperText>
					</FormControl>
				</UploadFormStep>

				{chooseProcessor()}
			</UploadTabSkeleton>
		</UploadFormProvider>
	);
};

export default StellarCellebriteTab;
